
import { useState, useEffect, useRef } from "react"
import EmojiPicker from "emoji-picker-react"
import "./ChatSystem.css"
import { createChat, getAllUserForChat, sendMessageApi, getAllUser, readAllChat } from "./services/Trainer/trainer"
import { useAuth } from "./context/AuthContext"
import { getAllUserForChatForStaff, getUserChat } from "./services/Staff/Staff"
import { initializePusher } from "./config/pusher"

// Dummy GIFs for demonstration
const dummyGifs = [
    "https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif",
    "https://media.giphy.com/media/26BRrSvJUa0crqw4E/giphy.gif",
    "https://media.giphy.com/media/l1J9u3TZfpmeDLkD6/giphy.gif",
    "https://media.giphy.com/media/3o7abKhOpu0NwenH3O/giphy.gif",
    "https://media.giphy.com/media/26BRBKqUiq586bRVm/giphy.gif",
    "https://media.giphy.com/media/3oEjHAUOqG3lSS0f1C/giphy.gif",
]

const ChatSystem = () => {
    const [showUserList, setShowUserList] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [chatId, setChatId] = useState(null)

    const [messages, setMessages] = useState({})
    const [currentMessage, setCurrentMessage] = useState("")
    const [showEmojiPicker, setShowEmojiPicker] = useState(false)
    const [showGifPicker, setShowGifPicker] = useState(false)
    const [users, setUsers] = useState([])
    const [pusherConnection, setPusherConnection] = useState(null)
    const [searchTerm, setSearchTerm] = useState("")
    const [loading, setLoading] = useState(false)
    const [pendingImages, setPendingImages] = useState([]) // Store images before sending
    const fileInputRef = useRef(null)
    const messagesEndRef = useRef(null)
    const { user } = useAuth()
    const [unreadCount, setUnreadCount] = useState(0);
    // Get initials for profile placeholder
    const getInitials = (name) => {
        return name ? name.charAt(0).toUpperCase() : "U"
    }

    // Fetch users for staff with search
    const fetchUserData = async (searchValue = "") => {
        try {
            setLoading(true)
            //   const formData = new FormData()
            //   if (searchValue) {
            //     formData.append("search", searchValue)
            //   }
            const data = await getAllUserForChatForStaff(searchValue)
            console.log("Staff users data:", data)
            if (data?.contacts) {
                setUsers(data.contacts)
            }
        } catch (error) {
            console.error("Failed to fetch staff users:", error)
        } finally {
            setLoading(false)
        }
    }

    // Fetch users for trainer and admin with search
    const fetchUserDataOfTrainerAndAdmin = async (searchValue = "") => {
        try {
            setLoading(true)
            //   const formData = new FormData()
            //   if (searchValue) {
            //     formData.append("search", searchValue)
            //   }
            const data = await getAllUserForChat(searchValue)
            // console.log("Trainer/Admin users data:", data)
            if (data?.contacts) {
                setUsers(data.contacts)
            }
        } catch (error) {
            // console.error("Failed to fetch trainer/admin users:", error)
        } finally {
            setLoading(false)
        }
    }

    // Fetch all users with search
    const fetchAllUsers = async () => {
        try {
            setLoading(true)
            //   const formData = new FormData()
            //   if (searchValue) {
            //     formData.append("search", searchValue)
            //   }
            const data = await getAllUser()
            console.log("All users data:", data)
            if (data?.contacts) {
                setUsers(data.contacts)
                const totalUnread = data.contacts.reduce(
                    (sum, user) => sum + (user.unreadCounts || 0),
                    0
                );
                setUnreadCount(totalUnread);
            }
        } catch (error) {
            console.error("Failed to fetch all users:", error)
        } finally {
            setLoading(false)
        }
    }

    // Handle search with API calls
    const handleSearch = async (searchValue) => {
        setSearchTerm(searchValue)

        if (user) {
            if (user.role === "admin" || user.role === "manager") {
                await fetchUserDataOfTrainerAndAdmin(searchValue)
            } else {
                await fetchUserData(searchValue)
            }
            // Also fetch from getAllUser API
            //   await fetchAllUsers(searchValue)
        }
    }

    // Initial user data fetch
    useEffect(() => {
        console.log("Current user:", user)
        if (user) {
            //   if (user.role === "admin" || user.role === "trainer") {
            //     fetchUserDataOfTrainerAndAdmin()
            //   } else {
            //     fetchUserData()
            //   }
            // Also fetch all users initially
            fetchAllUsers()
        }
    }, [user])

    // Fetch chat messages for selected user
    const fetchChat = async (selectedUser) => {
        if (selectedUser) {
            console.log("Fetching chat for user:", selectedUser)
            try {
                const payload = {
                    user: selectedUser._id,
                }
                const data = await getUserChat(payload)
                console.log("Chat data:", data)
                if (data) {
                    setMessages((prev) => ({
                        ...prev,
                        [selectedUser._id]: data,
                    }))
                }
            } catch (error) {
                console.error("Failed to fetch chat:", error)
            }
        }
    }

    // Initialize Pusher connection for a specific chat
    // const initializePusherForChat = (selectedUser) => {
    //     if (!user || !user._id || !selectedUser || !selectedUser._id) return
    //     console.log("sadfkjasdf", selectedUser)
    //     // if (pusherConnection) {
    //     //   pusherConnection.channel.unbind_all()
    //     //   pusherConnection.channel.unsubscribe()
    //     //   pusherConnection.pusher.disconnect()
    //     // }

    //     const { pusher, channel } = initializePusher(user._id, selectedUser._id, user.token)
    //     setPusherConnection({ pusher, channel })

    //     channel.bind("new-message", (data) => {
    //         console.log("New message received:sfdsafa", data)
    //         handleNewMessage(data)
    //     })

    //     channel.bind("user-online", (data) => {
    //         console.log("User came online:", data)
    //         updateUserOnlineStatus(data.userId, true)
    //     })

    //     channel.bind("user-offline", (data) => {
    //         console.log("User went offline:", data)
    //         updateUserOnlineStatus(data.userId, false)
    //     })
    // }

    // Update user online status
    const updateUserOnlineStatus = (userId, isOnline) => {
        setUsers((prev) => prev.map((user) => (user._id === userId ? { ...user, isOnline } : user)))
        if (selectedUser && selectedUser._id === userId) {
            setSelectedUser((prev) => ({ ...prev, isOnline }))
        }
    }

    // Handle new messages from Pusher
    const handleNewMessage = (data) => {
        console.log("Handling new message:asdsddsmfa.sd", data)
        if (data.sender === user._id || data.message?.sender === user._id) {
            console.log("Ignoring message from self to prevent duplicate")
            return
        }

        const senderId = data.sender || data.message?.sender
        const messageToAdd = data.message || data

        setMessages((prev) => {
            const userMessages = prev[senderId]
            if (userMessages?.messages) {
                const messageExists = userMessages.messages.some((msg) => msg._id === messageToAdd._id)
                if (messageExists) {
                    console.log("Message already exists, skipping")
                    return prev
                }
                return {
                    ...prev,
                    [senderId]: {
                        ...userMessages,
                        messages: [...userMessages.messages, messageToAdd],
                    },
                }
            }
            return {
                ...prev,
                [senderId]: {
                    ...userMessages,
                    messages: [messageToAdd],
                },
            }
        })

        setUsers((prev) => {
            const existingUsers = Array.isArray(prev) ? prev : [];
            const chatExists = existingUsers.some((user) => user.chatId === data.chatId);

            let updatedUsers;

            if (chatExists) {
                updatedUsers = existingUsers.map((user) =>
                    user._id === senderId
                        ? {
                            ...user,
                            lastMessage: messageToAdd.message,
                            unreadCounts: (user.unreadCounts || 0) + 1,
                            lastSeen: new Date(),
                        }
                        : user
                );
            } else {
                updatedUsers = [data?.newUser, ...existingUsers];
            }

           
            const totalUnread = updatedUsers.reduce(
                (sum, user) => sum + (user?.unreadCounts ? user?.unreadCounts : 0 ),
                0
            );

            console.log("Updated users:", updatedUsers);
            console.log("Total unread:", totalUnread);

            setUnreadCount(totalUnread);

            return updatedUsers;
        });

    }
    const readChat = async (id) => {
        if(id){
try {
            //   setLoading(true)
            //   const formData = new FormData()
            //   if (searchValue) {
            //     formData.append("search", searchValue)
            //   }
            const data = await readAllChat(id)
            console.log("read chat>>>>>>", data, users)
            if (data?.message == "Chat Read") {
                setUsers((prev) => {
                    const updatedUsers = prev.map((u) =>
                        u._id === selectedUser._id
                            ? { ...u, unreadCounts: 0, lastSeen: new Date() }
                            : u
                    );

                    const totalUnread = updatedUsers.reduce(
                        (sum, user) => sum + (user.unreadCounts || 0),
                        0
                    );

                    setUnreadCount(totalUnread);

                    return updatedUsers;
                });


            }

        } catch (error) {
            console.error("Failed to fetch all users:", error)
        } finally {
            //   setLoading(false)
        }
        }
        
    }
    // Scroll to bottom when messages change
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
        }
        if (selectedUser && selectedUser?._id) {
            const userMessages = messages[selectedUser._id]
            console.log("askjhfjkdsa", userMessages, selectedUser)
            if (userMessages) {
                readChat(userMessages?.chat?._id || chatId || '');
            }

        }
    }, [messages, selectedUser])

    const openUserList = () => {
        setShowUserList(true)
    }

    const closeUserList = () => {
        setShowUserList(false)
        setSelectedUser(null)
        setCurrentMessage("")
        setShowEmojiPicker(false)
        setShowGifPicker(false)
        setPendingImages([])

        // if (pusherConnection) {
        //   pusherConnection.channel.unbind_all()
        //   pusherConnection.channel.unsubscribe()
        //   pusherConnection.pusher.disconnect()
        //   setPusherConnection(null)
        // }
    }

    const openChat = (newSelectedUser) => {
        if (selectedUser && selectedUser._id === newSelectedUser._id) {
            return
        }

        setSelectedUser(newSelectedUser)
        setCurrentMessage("")
        setShowEmojiPicker(false)
        setShowGifPicker(false)
        setPendingImages([])

        setTimeout(() => {
            // initializePusherForChat(newSelectedUser)
            fetchChat(newSelectedUser)
        }, 100)
    }

    const closeChat = () => {
        setSelectedUser(null)
        setCurrentMessage("")
        setShowEmojiPicker(false)
        setShowGifPicker(false)
        setPendingImages([])
        setChatId(null)

        // if (pusherConnection) {
        //   pusherConnection.channel.unbind_all()
        //   pusherConnection.channel.unsubscribe()
        //   pusherConnection.pusher.disconnect()
        //   setPusherConnection(null)
        // }
    }

    const sendMessage = async () => {
        if ((!currentMessage.trim() && pendingImages.length === 0) || !selectedUser) return

        try {
            const userMessages = messages[selectedUser._id]

            // Create FormData for the message
            const formData = new FormData()

            if (userMessages?.messages?.length > 0) {
                formData.append("chatId", userMessages?.chat?._id ? userMessages?.chat?._id : chatId)
            } else {
                formData.append("user", selectedUser._id)
            }

            if (currentMessage.trim()) {
                formData.append("message", currentMessage)
            }

            // Add all pending images to FormData
            pendingImages.forEach((imageData, index) => {
                formData.append(`images`, imageData.file)
            })

            // Add type information
            let messageType = "text"
            if (pendingImages.length > 0 && currentMessage.trim()) {
                messageType = "mixed"
            } else if (pendingImages.length > 0) {
                messageType = "image"
            }
            formData.append("type", messageType)
            formData.append("userId", selectedUser._id)


            // if (userMessages?.messages?.length > 0) {
            // } else {
            //     response = await createChat(formData)
            // }
            const response = await sendMessageApi(formData)

           setChatId(response?.message?.chat)
            console.log("Message sent response:", response)

            // Create local message for immediate UI update
            const newMessage = {
                _id: Date.now().toString(),
                sender: user._id,
                message: currentMessage,
                images: pendingImages.map((img) => img.preview), // Store preview URLs
                files: pendingImages, // Store file data for download
                createdAt: new Date().toISOString(),
                type: messageType,
            }

            // Update local messages immediately
            setMessages((prev) => {
                const userMessages = prev[selectedUser._id]
                if (userMessages?.messages) {
                    return {
                        ...prev,
                        [selectedUser._id]: {
                            ...userMessages,
                            messages: [...userMessages.messages, newMessage],
                        },
                    }
                }
                return {
                    ...prev,
                    [selectedUser._id]: {
                        ...userMessages,
                        messages: [newMessage],
                    },
                }
            })

            // Update user's last message in the user list
            setUsers((prev) =>
                prev.map((u) =>
                    u._id === selectedUser._id ? { ...u, lastMessage: currentMessage, lastSeen: new Date() } : u,
                ),
            )

            // Clear current message and pending images
            setCurrentMessage("")
            setPendingImages([])
            setShowEmojiPicker(false)
        } catch (error) {
            console.error("Failed to send message:", error)
        }
    }

    const sendGif = async (gifUrl) => {
        if (!selectedUser) return

        try {
            const userMessages = messages[selectedUser._id]
            const formData = new FormData()

            if (userMessages?.messages?.length > 0) {
                // formData.append("chatId", userMessages?.chat?._id)
                formData.append("chatId", userMessages?.chat?._id ? userMessages?.chat?._id : chatId)

            } else {
                formData.append("user", selectedUser._id)
            }
            formData.append("message", gifUrl)
            formData.append("type", "gif")
            formData.append("userId", selectedUser._id)
         
             const response = await sendMessageApi(formData)
            setChatId(response?.message?.chat)
            // if (userMessages?.messages?.length > 0) {
            // } else {
            //     response = await createChat(formData)
            // }

            const newMessage = {
                _id: Date.now().toString(),
                sender: user._id,
                message: gifUrl,
                createdAt: new Date().toISOString(),
                type: "gif",
            }

            setMessages((prev) => {
                const userMessages = prev[selectedUser._id]
                if (userMessages?.messages) {
                    return {
                        ...prev,
                        [selectedUser._id]: {
                            ...userMessages,
                            messages: [...userMessages.messages, newMessage],
                        },
                    }
                }
                return {
                    ...prev,
                    [selectedUser._id]: {
                        ...userMessages,
                        messages: [newMessage],
                    },
                }
            })
           setUsers((prev) =>
                prev.map((u) =>
                    u._id === selectedUser._id ? { ...u, lastMessage: currentMessage, lastSeen: new Date() } : u,
                ),
            )
            setShowGifPicker(false)
        } catch (error) {
            console.error("Failed to send GIF:", error)
        }
    }

    const handleEmojiClick = (emojiObject) => {
        setCurrentMessage((prev) => prev + emojiObject.emoji)
        setShowEmojiPicker(false)
    }

    // Modified handleImageUpload - just add to pending images array, no API call
    const handleImageUpload = (event) => {
        const files = Array.from(event.target.files)

        files.forEach((file) => {
            if (!file) return

            const reader = new FileReader()
            reader.onload = (e) => {
                const imageData = {
                    file: file,
                    preview: e.target.result,
                    name: file.name,
                    type: file.type,
                    size: file.size,
                }

                setPendingImages((prev) => [...prev, imageData])
            }
            reader.readAsDataURL(file)
        })

        // Clear the input
        event.target.value = ""
    }

    // Remove pending image
    const removePendingImage = (index) => {
        setPendingImages((prev) => prev.filter((_, i) => i !== index))
    }

    // Download image/video function
    const downloadFile = (fileUrl) => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.target = "_blank"; // Opens in new tab
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const formatTime = (timestamp) => {
        return new Date(timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    }

    const filteredUsers = users.filter((user) => user?.fullName?.toLowerCase()?.includes(searchTerm.toLowerCase()))

    // Cleanup effect
    useEffect(() => {
        return () => {
            if (pusherConnection) {
                pusherConnection.channel.unbind_all()
                pusherConnection.channel.unsubscribe()
                pusherConnection.pusher.disconnect()
            }
        }
    }, [])

    useEffect(() => {
        if (user) {
            const { pusher, channel } = initializePusher("", "", user.token, user.privateChat)
            setPusherConnection({ pusher, channel })

            channel.bind("new-message", (data) => {
                console.log("New message received:", data)
                handleNewMessage(data)
                setUsers((prevUsers) =>
                    prevUsers.map((user) => (user._id === data.sender ? { ...user, lastMessage: data.message.message } : user)),
                )
            })
        }

        return () => {
            // if (pusherConnection) {
            //     pusherConnection.channel.unbind_all()
            //     pusherConnection.channel.unsubscribe()
            //     pusherConnection.pusher.disconnect()
            // }
        }
    }, [user])


    const handleClearSearch = () => {
        setSearchTerm("");
        fetchAllUsers();
    };
    return (
        <>
            {/* LinkedIn-style Dropdown Arrow */}
            <div className="position-relative" onClick={openUserList}>
                <div className="chat-system-dropdown-trigger d-flex align-items-center">
                    <span>Messaging</span>
                    <i className="bi bi-chevron-up ms-2"></i>

                    {unreadCount > 0 && (
                        <span
                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            style={{ fontSize: "10px" }}
                        >
                            {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                    )}
                </div>
            </div>
            {/* {
                console.log("users>>>>>>", users)
            } */}

            {/* User List Panel */}
            {showUserList && (
                <div className="chat-system-panel chat-system-user-list-panel">
                    <div className="chat-system-panel-header">
                        <h3 className="chat-system-panel-title">Messaging</h3>
                        <button type="button" className="chat-system-close-btn" onClick={closeUserList}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                    <div className="chat-system-panel-body">
                        <div className="chat-system-search-container">
                            <i className="bi bi-search chat-system-search-icon"></i>
                            <input
                                type="text"
                                className="chat-system-search-input"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                            {searchTerm && (
                                <i
                                    className="bi bi-x chat-system-search-icon"
                                    onClick={handleClearSearch}
                                    style={{ right: '30px', left: 'unset' }}
                                ></i>
                            )}
                        </div>
                        <div className="chat-system-users-list" >
                            {loading ? (
                                <div className="chat-system-loading">Loading users...</div>
                            ) : (
                                filteredUsers?.length > 0 ?
                                    filteredUsers.map((user) => (
                                        <div
                                            key={user._id}
                                            className={`chat-system-user-item ${selectedUser && selectedUser._id === user._id ? "chat-system-user-item-active" : ""
                                                } ${user.unreadCounts > 0 ? "chat-system-user-item-unread" : ""}`}
                                            onClick={() => openChat(user)}
                                        >
                                            <div className="chat-system-user-avatar-container">
                                                {user?.profileImageUrl ? (
                                                    <img
                                                        src={`${process.env.REACT_APP_BUCKET_URL}${user?.profileImageUrl}`}
                                                        alt={user.fullName}
                                                        className="chat-system-user-avatar"
                                                    />
                                                ) : (
                                                    <div className="chat-system-user-avatar-placeholder">{getInitials(user?.fullName || "")}</div>
                                                )}
                                                {user.isOnline && <div className="chat-system-online-indicator"></div>}
                                            </div>
                                            <div className="chat-system-user-info">
                                                <div className="chat-system-user-name">{user.fullName}</div>
                                                <div className="chat-system-user-status">{user?.lastMessage}</div>
                                            </div>
                                            {user.unreadCounts > 0 && <div className="chat-system-unread-badge">{user.unreadCounts}</div>}
                                        </div>
                                    ))
                                    :
                                    <div className="d-flex justify-content-center align-items-center flex-column  text-secondary p-3 pt-5">
                                        <i className="bi bi-person-lines-fill display-4 mb-3"></i>
                                        <span>Please search for a user to start chatting.</span>
                                    </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Single Chat Panel */}
            {selectedUser && (
                <div className="chat-system-panel chat-system-chat-panel">
                    <div className="chat-system-panel-header">
                        <div className="chat-system-chat-user-info">
                            {selectedUser?.profileImageUrl ? (
                                <img
                                    src={`${process.env.REACT_APP_BUCKET_URL}${selectedUser?.profileImageUrl}`}
                                    alt={selectedUser.fullName}
                                    className="chat-system-chat-avatar"
                                />
                            ) : (
                                <div className="chat-system-chat-avatar-placeholder">{getInitials(selectedUser?.fullName || "")}</div>
                            )}
                            <div className="chat-system-user-details">
                                <div className="chat-system-chat-user-name">{selectedUser.fullName}</div>
                                <small className="chat-system-chat-user-status">
                                    {selectedUser.isOnline
                                        ? "Available on PC"
                                        : `Last seen ${formatTime(selectedUser.lastSeen || new Date())}`}
                                </small>
                            </div>
                        </div>
                        <div className="chat-system-chat-actions">
                            <button className="chat-system-action-btn">
                                <i className="bi bi-three-dots"></i>
                            </button>
                            <button className="chat-system-action-btn">
                                <i className="bi bi-dash"></i>
                            </button>
                            <button type="button" className="chat-system-close-btn" onClick={closeChat}>
                                <i className="bi bi-x"></i>
                            </button>
                        </div>
                    </div>
                    <div className="chat-system-panel-body">
                        <div className="chat-system-messages-container">
                            {messages[selectedUser._id]?.messages
                                ?.slice()
                                ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                ?.map((msg) => (
                                    <div
                                        key={msg._id}
                                        className={`chat-system-message ${msg.sender === user._id ? "chat-system-message-sent" : "chat-system-message-received"
                                            }`}
                                    >
                                        {msg.sender !== user._id && (
                                            <div className="chat-system-message-avatar-container">
                                                {selectedUser?.profileImageUrl ? (
                                                    <img
                                                        src={`${process.env.REACT_APP_BUCKET_URL}${selectedUser?.profileImageUrl}`}
                                                        alt={selectedUser.fullName}
                                                        className="chat-system-message-avatar"
                                                    />
                                                ) : (
                                                    <div className="chat-system-message-avatar-placeholder">
                                                        {getInitials(selectedUser?.fullName || "")}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="chat-system-message-content">
                                            {msg.type === "image" ? (
                                                <div className="chat-system-message-images">
                                                    {(msg?.files || [msg?.files]).map((imageUrl, index) => (
                                                        <div key={index} className="chat-system-image-container">
                                                            {imageUrl?.type?.includes("image") ? (
                                                                <img
                                                                    src={`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}` || "/placeholder.svg"}
                                                                    alt="Uploaded"
                                                                    className="chat-system-message-image"
                                                                />
                                                            ) : (
                                                                // <video
                                                                // controls
                                                                // className="chat-system-message-image"
                                                                // >
                                                                // <source
                                                                //     src={`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}`}
                                                                // />
                                                                // Your browser does not support the video tag.
                                                                // </video>
                                                                <div className=" " style={{ backgroundColor: 'black', height: '400px' }}>
                                                                    <div className='px-3'>
                                                                        <video
                                                                            width="100%"
                                                                            height="400"
                                                                            src={`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}`}
                                                                            controls
                                                                        //   onEnded={onVideoEnd}
                                                                        />
                                                                    </div>
                                                                </div>


                                                            )}
                                                            <button
                                                                className="chat-system-download-btn"
                                                                onClick={() => downloadFile(`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}`, `image-${index + 1}`)}
                                                                title="Download"
                                                            >
                                                                <i className="bi bi-download"></i>
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : msg.type === "mixed" ? (
                                                <div className="chat-system-message-mixed">
                                                    {msg?.files && msg?.files.length > 0 && (
                                                        <div className="chat-system-message-images">
                                                            {msg?.files.map((imageUrl, index) => (
                                                                <div key={index} className="chat-system-image-container">
                                                                    {imageUrl?.type?.includes("image") ? (
                                                                        <img
                                                                            src={`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}` || "/placeholder.svg"}
                                                                            alt="Uploaded"
                                                                            className="chat-system-message-image"
                                                                        />
                                                                    ) : (
                                                                        <video
                                                                            controls
                                                                            className="chat-system-message-image"
                                                                        >
                                                                            <source
                                                                                src={`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}`}
                                                                                type={imageUrl?.type || "video/mp4"}
                                                                            />
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                    )}
                                                                    <button
                                                                        className="chat-system-download-btn"
                                                                        onClick={() => downloadFile(`${process.env.REACT_APP_BUCKET_URL}${imageUrl.url}`, `image-${index + 1}`)}
                                                                        title="Download"
                                                                    >
                                                                        <i className="bi bi-download"></i>
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {msg.message && <div className="chat-system-message-text">{msg.message}</div>}
                                                </div>
                                            ) : msg.type === "gif" ? (
                                                <div className="chat-system-image-container">
                                                    <img src={msg.message || "/placeholder.svg"} alt="GIF" className="chat-system-message-gif" />
                                                    <button
                                                        className="chat-system-download-btn"
                                                        onClick={() => downloadFile(msg.message, "gif")}
                                                        title="Download"
                                                    >
                                                        <i className="bi bi-download"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="chat-system-message-text">{msg.message}</div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            <div ref={messagesEndRef} />
                        </div>
                    </div>

                    {/* Pending Images Preview */}
                    {/* {pendingImages.length > 0 && (
                        <div className="chat-system-pending-images">
                            <div className="chat-system-pending-images-header">
                                <span>Images to send ({pendingImages.length})</span>
                            </div>
                            <div className="chat-system-pending-images-grid">
                                {pendingImages.map((imageData, index) => (
                                    <div key={index} className="chat-system-pending-image">
                                        <img src={imageData.preview || "/placeholder.svg"} alt={imageData.name} />
                                        <button className="chat-system-remove-image-btn" onClick={() => removePendingImage(index)}>
                                            <i className="bi bi-x"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )} */}

                    {pendingImages.length > 0 && (
                        <div className="chat-system-pending-media">
                            <div className="chat-system-pending-images-header">
                                <span>Media to send ({pendingImages.length})</span>
                            </div>
                            <div className="chat-system-pending-images-grid" style={{ marginLeft: '5px' }}>
                                {pendingImages.map((media, index) => (
                                    <div key={index} className="chat-system-pending-image">
                                        {media.type === "image" ? (
                                            <img src={media.preview} alt={media.name} />
                                        ) : (
                                            <video src={media.preview} controls preload="metadata" style={{ width: '100px', height: '100px' }} />
                                        )}
                                        <button
                                            className="chat-system-remove-image-btn"
                                            onClick={() => removePendingImage(index)}
                                        >
                                            <i className="bi bi-x"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="chat-system-panel-footer">
                        <div className="chat-system-input-container">
                            <div className="chat-system-input-actions">
                                <button className="chat-system-input-btn" onClick={() => fileInputRef.current?.click()}>
                                    <i className="bi bi-paperclip"></i>
                                </button>
                                {/* <button className="chat-system-input-btn" onClick={() => setShowGifPicker(!showGifPicker)}>
                  <i className="bi bi-link-45deg"></i>
                </button> */}
                                <button className="chat-system-input-btn" onClick={() => setShowGifPicker(!showGifPicker)}>
                                    GIF
                                </button>
                                <button className="chat-system-input-btn" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                                    <i className="bi bi-emoji-smile"></i>
                                </button>
                            </div>
                            <input
                                type="text"
                                className="chat-system-message-input"
                                placeholder="Write a message"
                                value={currentMessage}
                                onChange={(e) => setCurrentMessage(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault()
                                        sendMessage()
                                    }
                                }}
                            />
                            <button className="chat-system-send-btn" onClick={sendMessage}>
                                <i className="bi bi-send-fill"></i>
                            </button>
                        </div>

                        {/* Emoji Picker */}
                        {showEmojiPicker && (
                            <div className="chat-system-picker-container">
                                <EmojiPicker onEmojiClick={handleEmojiClick} />
                            </div>
                        )}

                        {/* GIF Picker */}
                        {showGifPicker && (
                            <div className="chat-system-picker-container">
                                <div className="chat-system-gif-picker">
                                    <div className="chat-system-gif-header">
                                        <h6>Choose a GIF</h6>
                                    </div>
                                    <div className="chat-system-gif-grid">
                                        {dummyGifs.map((gif, gifIndex) => (
                                            <img
                                                key={gifIndex}
                                                src={gif || "/placeholder.svg"}
                                                alt={`GIF ${gifIndex + 1}`}
                                                className="chat-system-gif-item"
                                                onClick={() => sendGif(gif)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Hidden file input */}
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/*,video/*"
                            multiple
                            onChange={handleImageUpload}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default ChatSystem
